import { ReactNode } from 'react';
import { SafeAreaView, ScrollView, View } from 'react-native';
import { GlobalPopup } from '@/screens/HomeTherapist/GlobalPopup';
import { NewUIFeatureModal } from '@/components/NewUIFeatureModal';
import { CollapsibleBody } from '@/components/ui/therapist/CollapsibleBody';
import { CollapsibleSidebar } from '@/components/ui/therapist/CollapsibleSidebar';

import { styles } from './styles';

export const BodyWrapper = ({
  children,
  bodyStyle,
  ref,
  scrollEnabled,
  showSidebar = true,
}: {
  children: ReactNode;
  bodyStyle?: object;
  ref?: React.Ref<ScrollView>;
  scrollEnabled?: boolean;
  showSidebar?: boolean;
}) => {
  return (
    <View style={{ flex: 1 }}>
      <SafeAreaView style={{ flex: 1 }}>
        <View style={styles.container}>
          <GlobalPopup />
          <NewUIFeatureModal />
          {!!showSidebar && <CollapsibleSidebar />}
          <CollapsibleBody scrollEnabled={scrollEnabled} ref={ref}>
            <View style={[styles.innerBodyWrapper, bodyStyle]}>{children}</View>
          </CollapsibleBody>
        </View>
      </SafeAreaView>
    </View>
  );
};
